// extracted by mini-css-extract-plugin
export default {"kebabActKc2":"KebabActKC2_kebabActKc2__rc1ih","kebabActKc2MenuItem":"KebabActKC2_kebabActKc2MenuItem__3crRA"};